import React, { useState, useEffect } from 'react';
import { api } from '../services/api';

// Icône de fermeture stylisée
const X = ({ onClick, className = '' }) => (
  <button 
    onClick={onClick}
    className={`w-8 h-8 rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors ${className}`}
    aria-label="Fermer"
  >
    <span className="text-2xl text-gray-500 hover:text-gray-700">×</span>
  </button>
);

// Composant pour le formulaire de création d'admin
const CreateAdminForm = ({ onCreate, onCancel }) => {
  const [formData, setFormData] = useState({
    firstName: 'Admin',
    lastName: 'Liberty',
    email: 'admin@liberty.com',
    password: 'Admin@1234',
    confirmPassword: 'Admin@1234'
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (formData.password !== formData.confirmPassword) {
      return setError('Les mots de passe ne correspondent pas');
    }
    
    try {
      setLoading(true);
      
      // Utiliser toujours createFirstAdmin car on est dans ce formulaire uniquement si aucun admin n'existe
      const result = await api.createFirstAdmin(formData);
      if (!result.success) {
        throw new Error(result.message || 'Erreur lors de la création du compte administrateur');
      }
      
      // Si on arrive ici, la création a réussi
      if (onCreate) {
        await onCreate(formData.email, formData.password);
      }
    } catch (err) {
      console.error('Erreur création admin:', err);
      setError(err.message || 'Erreur lors de la création du compte administrateur');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full max-w-md mx-auto bg-white rounded-xl shadow-2xl overflow-hidden">
      <div className="p-8">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-900">Nouvel Administrateur</h2>
          <X onClick={onCancel} className="-mr-2" />
        </div>
        
        {error && (
          <div className="mb-6 p-3 bg-red-50 border-l-4 border-red-500 text-red-700 rounded">
            <p className="font-medium">Erreur</p>
            <p className="text-sm">{error}</p>
          </div>
        )}
        
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Prénom</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                placeholder="Votre prénom"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Nom</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                placeholder="Votre nom"
                required
              />
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                placeholder="email@exemple.com"
                required
              />
            </div>
          </div>
          
          <div className="grid grid-cols-1 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Mot de passe</label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                placeholder="••••••••"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Confirmer le mot de passe</label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                placeholder="••••••••"
                required
              />
            </div>
          </div>
          
          <div className="pt-2">
            <button
              type="submit"
              disabled={loading}
              className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {loading ? (
                <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Création en cours...
                </>
              ) : 'Créer le compte administrateur'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default function AdminQuickLoginModal({ open, onClose, onSuccess }) {
  const [email, setEmail] = useState('admin@liberty.com');
  const [password, setPassword] = useState('Admin@1234');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [adminExists, setAdminExists] = useState(null); // null = vérification en cours
  const [checking, setChecking] = useState(true);
  const [connectionError, setConnectionError] = useState(false);
  
  // Vérifier si un admin existe déjà
  useEffect(() => {
    const checkAdminExists = async () => {
      try {
        setChecking(true);
        setConnectionError(false);
        const response = await api.checkAdminExists();
        setAdminExists(response.exists);
      } catch (err) {
        console.error('Erreur vérification admin:', err);
        // Si c'est une erreur de connexion, afficher un message spécial
        if (err.message && err.message.includes('se connecter au serveur')) {
          setConnectionError(true);
          setError('Impossible de se connecter au serveur backend. Veuillez vérifier que le serveur est démarré.');
        } else {
          // Pour les autres erreurs, permettre la création (mode dégradé)
          setAdminExists(false);
        }
      } finally {
        setChecking(false);
      }
    };
    
    if (open) {
      checkAdminExists();
    }
  }, [open]);
  
  const handleAdminCreated = async (createdEmail, createdPassword) => {
    // Après création, vérifier à nouveau et afficher le formulaire de connexion
    try {
      const response = await api.checkAdminExists();
      if (response.exists) {
        setAdminExists(true);
        // Pré-remplir les champs avec les identifiants créés
        setEmail(createdEmail || 'admin@liberty.com');
        setPassword(createdPassword || 'Admin@1234');
      }
    } catch (err) {
      console.error('Erreur vérification après création:', err);
      // En cas d'erreur, supposer que l'admin a été créé
      setAdminExists(true);
      setEmail(createdEmail || 'admin@liberty.com');
      setPassword(createdPassword || 'Admin@1234');
    }
  };

  useEffect(() => {
    if (open) {
      setEmail('');
      setPassword('');
      setError('');
    }
  }, [open]);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === 'Escape') {
        onClose?.();
      }
    };
    if (open) {
      window.addEventListener('keydown', handler);
    }
    return () => window.removeEventListener('keydown', handler);
  }, [open, onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.adminLogin(email, password);
      if (!res.success) throw new Error(res.message || "Authentification échouée");
      
      localStorage.setItem('token', res.token);
      localStorage.setItem('user', JSON.stringify(res.user || {}));
      localStorage.setItem('userType', 'admin');
      onSuccess?.();
    } catch (err) {
      setError(err?.message || 'Erreur lors de la connexion administrateur');
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;
  
  // Afficher un loader pendant la vérification
  if (checking) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div 
          className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity" 
          onClick={onClose}
          aria-hidden="true"
        />
        <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
          <div className="flex flex-col items-center justify-center">
            <svg className="animate-spin h-8 w-8 text-indigo-600 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <p className="text-gray-600">Vérification en cours...</p>
          </div>
        </div>
      </div>
    );
  }
  
  // Afficher un message d'erreur de connexion
  if (connectionError) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div 
          className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity" 
          onClick={onClose}
          aria-hidden="true"
        />
        <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="p-8">
            <div className="flex justify-between items-start mb-6">
              <div>
                <h2 className="text-2xl font-bold text-gray-900">Erreur de connexion</h2>
                <p className="text-sm text-gray-500 mt-1">Le serveur backend n'est pas accessible</p>
              </div>
              <X onClick={onClose} className="-mt-1 -mr-1" />
            </div>
            
            <div className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 rounded">
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-sm text-red-700 font-medium">Impossible de se connecter au serveur</p>
                  <p className="text-sm text-red-600 mt-1">{error}</p>
                </div>
              </div>
            </div>
            
            <div className="space-y-3">
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-sm text-gray-700 font-medium mb-2">Vérifications à effectuer :</p>
                <ul className="text-sm text-gray-600 space-y-1 list-disc list-inside">
                  <li>Le serveur backend est-il démarré ?</li>
                  <li>L'adresse du serveur est-elle correcte ?</li>
                  <li>Y a-t-il un problème de réseau ou de pare-feu ?</li>
                </ul>
              </div>
              
              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setConnectionError(false);
                    setChecking(true);
                    setError('');
                    // Réessayer la vérification
                    api.checkAdminExists()
                      .then(response => {
                        setAdminExists(response.exists);
                        setConnectionError(false);
                      })
                      .catch(err => {
                        console.error('Erreur vérification admin:', err);
                        if (err.message && err.message.includes('se connecter au serveur')) {
                          setConnectionError(true);
                          setError(err.message);
                        }
                      })
                      .finally(() => setChecking(false));
                  }}
                  className="flex-1 py-2 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
                >
                  Réessayer
                </button>
                <button
                  type="button"
                  onClick={onClose}
                  className="flex-1 py-2 px-4 border border-gray-300 rounded-lg shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors"
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  
  // Afficher le formulaire de création si aucun admin n'existe
  if (!adminExists) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div 
          className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity" 
          onClick={onClose}
          aria-hidden="true"
        />
        <div className="relative w-full max-w-md max-h-[90vh] overflow-y-auto">
          <CreateAdminForm 
            onCreate={handleAdminCreated}
            onCancel={onClose}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity" 
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl overflow-hidden">
        <div className="p-8">
          <div className="flex justify-between items-start mb-6">
            <div>
              <h2 className="text-2xl font-bold text-gray-900">
                Connexion Administrateur
              </h2>
              <p className="text-sm text-gray-500 mt-1">
                Entrez vos identifiants pour accéder au tableau de bord
              </p>
            </div>
            <X onClick={onClose} className="-mt-1 -mr-1" />
          </div>
          
          {error && (
            <div className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 rounded">
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-sm text-red-700">{error}</p>
                </div>
              </div>
            </div>
          )}
          
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                Adresse email
              </label>
              <div className="mt-1 relative rounded-md shadow-sm">
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                  placeholder="email@exemple.com"
                  required
                />
              </div>
            </div>
            
            <div>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                  Mot de passe
                </label>
                <button type="button" className="text-sm font-medium text-indigo-600 hover:text-indigo-500">
                  Mot de passe oublié ?
                </button>
              </div>
              <div className="mt-1 relative rounded-md shadow-sm">
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                  placeholder="••••••••"
                  required
                />
              </div>
            </div>

            <div className="pt-2">
              <button
                type="submit"
                disabled={loading}
                className={`w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors ${
                  loading ? 'opacity-75 cursor-not-allowed' : ''
                }`}
              >
                {loading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Connexion en cours...
                  </>
                ) : (
                  'Se connecter'
                )}
              </button>
              
              <div className="mt-4 text-center">
                <p className="text-xs text-gray-500">
                  Vous n'êtes pas administrateur ?{' '}
                  <button type="button" className="text-indigo-600 hover:text-indigo-500 font-medium" onClick={onClose}>
                    Retour à l'accueil
                  </button>
                </p>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}